import React from 'react';
import CampaignMemberFilter from './components/CampaignMemberFilter';

function App() {
  return (
    <div className="App">
      <CampaignMemberFilter />
    </div>
  );
}

export default App;